import { Field, NumericInput, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection, PageSection } from 'Components/Layout';
import {
  WorksheetAssociatedTestSection,
  WorksheetGridFieldSection,
  WorksheetRecordGrid,
} from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import externalTestMethods from 'Components/Worksheets/ExternalTestMethods';
import { combine } from 'Lib/Hooks/Selectors';
import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

let OversizeDeterminationSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const externalSieveResultHeadings = useSelector(
    combine(
      [
        createWorksheetSelector!(`Preparation.AssociatedOversizeDetermination.ExternalTest.Results.AllSieves`),
        createWorksheetSelector!(`Preparation.AssociatedOversizeDetermination.ExternalTest.Results.Sieves`),
      ],
      (allSieves, sieveRecords) =>
        (sieveRecords ?? []).map(
          (r: any) => allSieves?.find((s: any) => s.Id === r.SieveId)?.Caption ?? r.Id
        ) as Array<string>
    ),
    shallowEqual
  );

  return (
    <PageSection heading="Oversize Determination">
      <WorksheetAssociatedTestSection
        label="Oversize proportion determined by:"
        name="Preparation.AssociatedOversizeDetermination"
        testType="Oversize Determination"
        associatedTestModel={{
          measured: true,
          external: {
            permitOtherTestMethods: true,
            testMethods: [
              externalTestMethods.psdSieveAnalysis.ARIZ_201e,
              externalTestMethods.psdSieveAnalysis.ASTM_C136,
              externalTestMethods.psdSieveAnalysis.ASTM_D6913,
            ],
            externalTestResults: (
              <WorksheetGridFieldSection
                name={'Preparation.AssociatedOversizeDetermination.ExternalTest.Results.Sieves'}
              >
                <WorksheetRecordGrid
                  name={'Preparation.AssociatedOversizeDetermination.ExternalTest.Results.Sieves'}
                  fieldSet={[
                    {
                      name: 'CumulativeDryMassRetainedPercent',
                      component: <Field input={<NumericInput />} />,
                      width: 130,
                    },
                  ]}
                  recordProps={{
                    enforceAtLeastOneRecord: false,
                    preventCreate: true,
                    preventRemove: true,
                    headingLabel: 'Sieve Size',
                    heading: (i: number) => externalSieveResultHeadings[i],
                  }}
                  rowHeaderWidth={110}
                  orientation={'vertical'}
                />
              </WorksheetGridFieldSection>
            ),
          },
        }}
      />

      <ListFieldSection>
        <Field input={<TextOutput />} label="Oversize Sieve" name="Preparation.ScreeningASTM.OversizeSieve.Caption" />
        <Field input={<TextOutput />} label="Oversize (%)" name="Preparation.ScreeningASTM.OversizePercent" />
      </ListFieldSection>
    </PageSection>
  );
};

OversizeDeterminationSection = withInjectedProps(OversizeDeterminationSection);

export { OversizeDeterminationSection };
export default OversizeDeterminationSection;
